import React from 'react';
import { AiOutlineReload } from 'react-icons/ai';
import { FaChartLine, FaPlug } from 'react-icons/fa';
import { HiDocumentSearch } from 'react-icons/hi';
import './style.scoped.scss';

const InfoAPI = ({ isSmallScreen = false }) => {
  const features = [
    {
      icon: <HiDocumentSearch />,
      title: 'Comprehensive Regulatory Access',
      description:
        'Instantly access 750+ digitalised financial regulations from ASIC, APRA, AUSTRAC, ACCC, OAIC, and RBA using the RegulationCity API.',
    },
    {
      icon: <AiOutlineReload />,
      title: 'Always Up-to-Date',
      description:
        'Stay current with the latest regulatory changes through automatic real-time updates, ensuring compliance at all times',
    },
    {
      icon: <FaPlug />,
      title: 'Effortless Integration',
      description:
        'Seamlessly integrate our API into your systems, saving development time and resources.',
    },
    {
      icon: <FaChartLine />,
      title: 'Competitive Edge',
      description:
        'Offer your customers an accurate regulatory and GRC solution, setting your product apart in the market.',
    },
  ];
  return (
    <div className='apiFeatures' id='api-features'>
      <b className='apiFeatures__title'>RegulationCity API</b>
      <p className='apiFeatures__subtitle'>
        The RegulationCity API provides you with the capability to easily
        search, retrieve, and receive alerts for regulatory information directly
        within the platforms you are already using.
      </p>
      <div className='apiFeatures__features'>
        <div className='row'>
          {features.map((item, index) => {
            return (
              <div className='col-6 smallIcons' key={index}>
                <div className='apiFeatures__features'>
                  <div className='apiFeatures__features__background'>
                    <span className='apiFeatures__features__icon'>
                      {item.icon}
                    </span>
                  </div>
                  <b className='apiFeatures__features__title'>{item.title}</b>
                  <p className='apiFeatures__features__description'>
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InfoAPI;
